export const DOMAIN_ROUTES = {
  TEMPLATE_PREVIEW: 'template-preview',
  UNDER_CONSTRUCTION: 'under-construction',
  NOT_FOUND: 'not-found',
};
